<template>
    <div>
        <svg :width="iconSize" :height="iconSize" viewBox="0 0 18 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M10 1.25251C10 0.138879 8.65358 -0.418836 7.86612 0.368623L4.11612 4.11862H2.50755C1.55643 4.11862 0.57588 4.67232 0.291087 5.70617C0.101225 6.3954 0 7.12069 0 7.86862C0 8.61656 0.101225 9.34185 0.291087 10.0311C0.57588 11.0649 1.55643 11.6186 2.50755 11.6186H4.11612L7.86612 15.3686C8.65358 16.1561 10 15.5984 10 14.4847V1.25251Z"
                :fill="color" 
            />
            <path
                d="M13.5669 5.55167C13.3229 5.30759 12.9271 5.30759 12.6831 5.55167C12.439 5.79575 12.439 6.19148 12.6831 6.43556L14.1161 7.86861L12.6831 9.30167C12.439 9.54575 12.439 9.94148 12.6831 10.1856C12.9271 10.4296 13.3229 10.4296 13.5669 10.1856L15 8.7525L16.4331 10.1856C16.6771 10.4296 17.0729 10.4296 17.3169 10.1856C17.561 9.94148 17.561 9.54575 17.3169 9.30167L15.8839 7.86861L17.3169 6.43556C17.561 6.19148 17.561 5.79575 17.3169 5.55167C17.0729 5.30759 16.6771 5.30759 16.4331 5.55167L15 6.98473L13.5669 5.55167Z"
                :fill="color" 
            />
        </svg>
    </div>
</template>

<script>
export default {
    name: 'IconSvgVolumeDown',
    props: {
        color: {
            type: String,
            default: '#000000',
        },
        size: {
            type: Number,
            default: null
        }
    },
    computed: {
        iconSize() {
            return this.size ? `${this.size}px` : '44px'
        }
    }
};
</script>

<style scoped></style>